import React, { useEffect, useState, useRef, useCallback } from 'react'
import textFit from 'textfit'
import { ICard } from 'models'
import { UIColorThemes, boldWords } from 'global'
import { Box, Text } from 'components'

interface ISexResultCard extends Required<Pick<ICard, 'ways'>> {
  uiColorTheme: UIColorThemes
  onLoaded: () => void
  hasTip: boolean
}

export const SexResultCard = ({
  ways,
  uiColorTheme,
  onLoaded,
  hasTip,
}: ISexResultCard) => {
  const ref = useRef<HTMLDivElement>(null)
  const contentRef = useRef<HTMLParagraphElement>(null)
  const [opacity, setOpacity] = useState(0)
  const text = boldWords(ways)
  const loadedCb = useCallback(onLoaded, [])

  useEffect(() => {
    if (ref.current && contentRef.current) {
      textFit(contentRef.current, {
        minFontSize: 8,
        maxFontSize: 28,
        multiLine: true,
      })
      setOpacity(1)
      loadedCb()
    }
  }, [setOpacity, loadedCb])

  return (
    <Box ref={ref} opacity={opacity}>
      <Text
        ref={contentRef}
        // textFit needs a height to vertically scale.
        height={hasTip ? '240px' : '320px'}
        color={uiColorTheme === 'light' ? '#fff' : '#000'}
        lineHeight='normal'
      >
        During sex I like {text}.
      </Text>
    </Box>
  )
}
